import { ModelsReviewView } from "../_components";

export default function ContentModelsReviewPage() {
  return <ModelsReviewView />;
}
